export interface SegmentOrderShift {
  clientId: string
  newOrder: number
}

/**
 * The backend batch endpoint is only atomic per event, so a partial batch can
 * leave behind whatever prefix was already applied. Emit right-shifts from high
 * to low order and left-shifts from low to high order so every applied prefix
 * keeps segment orders unique and deterministic.
 */
export function sortSegmentOrderShiftsForEmission(
  orderShifts: SegmentOrderShift[],
  survivorOriginalOrder: Map<string, number>,
): SegmentOrderShift[] {
  const shiftsRight: SegmentOrderShift[] = []
  const shiftsLeft: SegmentOrderShift[] = []

  for (const shift of orderShifts) {
    const originalOrder = survivorOriginalOrder.get(shift.clientId)
    if (originalOrder === undefined || originalOrder === shift.newOrder) continue

    if (shift.newOrder > originalOrder) {
      shiftsRight.push(shift)
    } else {
      shiftsLeft.push(shift)
    }
  }

  shiftsRight.sort((a, b) => b.newOrder - a.newOrder || a.clientId.localeCompare(b.clientId))
  shiftsLeft.sort((a, b) => a.newOrder - b.newOrder || a.clientId.localeCompare(b.clientId))

  return [...shiftsRight, ...shiftsLeft]
}
